import { FrameName } from "../config";
import AbstractSalvageableFightableEnemyTileEntity from "./AbstractSalvageableFightableEnemyTileEntity";

class ChieftainEnemySalvageableTileEntity extends AbstractSalvageableFightableEnemyTileEntity {
	public static readonly frameName = FrameName.CHIEFTAIN_ENEMY;
}

export default ChieftainEnemySalvageableTileEntity;
